module.exports = "img/flags/SD.38ae49b.png";